import React, { useEffect } from 'react';
import { PersonaProvider } from './components/PersonaContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PersonaSelector } from './components/PersonaSelector';
import { Pain } from './components/Pain';
import { Services } from './components/Services';
import { CostComparison } from './components/CostComparison';
import { TrustBlock } from './components/TrustBlock';
import { FAQ } from './components/FAQ';
import { CustomerJourney } from './components/CustomerJourney';
import { LeadCapture } from './components/LeadCapture';
import { Footer } from './components/Footer';
import { MobileCTABar } from './components/MobileCTABar';
export function App() {
  useEffect(() => {
    const prefersReduced = typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    const sections = document.querySelectorAll('main > section');
    sections.forEach(s => s.classList.add('reveal-pending'));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('reveal-pending');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    sections.forEach(s => observer.observe(s));
    // Make sure the hero (in view on load) reveals immediately
    requestAnimationFrame(() => {
      sections.forEach(s => {
        const rect = s.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          s.classList.remove('reveal-pending');
          s.classList.add('is-visible');
          observer.unobserve(s);
        }
      });
    });
    return () => observer.disconnect();
  }, []);
  return <PersonaProvider data-id="element-0">
      <div className="min-h-screen flex flex-col font-sans text-charcoal bg-white selection:bg-knight-orange/20 selection:text-charcoal" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Hero data-id="element-4" />
          <PersonaSelector data-id="element-5" />
          <Pain data-id="element-6" />
          <Services data-id="element-7" />
          <CostComparison data-id="element-8" />
          <TrustBlock data-id="element-9" />
          <FAQ data-id="element-10" />
          <CustomerJourney data-id="element-11" />
          <LeadCapture data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <MobileCTABar data-id="element-14" />
      </div>
    </PersonaProvider>;
}